import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Piano.css";

class Piano extends Component {
  static propTypes = {
    currentNote: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.notePlayed = null;
  }

  drawPiano = (note) => {
    console.log("Piano:",note);
    let piano = document.getElementById("piano_svg")
    if (piano && this.notePlayed !== null) {
      this.notePlayed.classList.remove("pianoisPressed");
    }
    if (note && piano) {
      if(note.indexOf('♭')!==-1 || note.indexOf("#")!==-1){
        let elements = piano.getElementsByTagName('rect');
        for(let i=0;i<elements.length;i++){
          let element = elements[i];
          let id = element.getAttribute('id');
          if(id.indexOf(note)!==-1){
            element.classList.add('pianoisPressed')
            this.notePlayed = element
            break;
          }
        }
      }else{
        let hilightItem = piano.getElementById(note);
        if (hilightItem) {
          hilightItem.classList.add("pianoisPressed");
          this.notePlayed = hilightItem;
        }
      }
      
    }

    return (
      <g id="Group_165" transform="translate(426.759 -9.927)">
        <rect
          id="Rectangle_260"
          x="-426.3"
          y="126.3"
          className="piano-footer "
          width="414.3"
          height="18.7"
        />
        <rect
          id="Rectangle_261"
          x="-426.3"
          y="10"
          className="st1"
          width="414.3"
          height="18.7"
        />
        <path
          id="Do1"
          className="st2"
          d="M-371.4,10.4h27.4l0,0v116.1c0,1.7-1.3,3-3,3h-21.4c-1.7,0-3-1.3-3-3V10.4L-371.4,10.4z"
        />
        <path
          id="Re1"
          className="st2"
          d="M-343.4,10.6h27.4l0,0v116.1c0,1.7-1.3,3-3,3h-21.4c-1.7,0-3-1.3-3-3V10.6L-343.4,10.6z"
        />
        <path
          id="Mi1"
          className="st2"
          d="M-315.7,10.6h27.4l0,0v116.1c0,1.7-1.3,3-3,3h-21.4c-1.7,0-3-1.3-3-3V10.6L-315.7,10.6z"
        />
        <path
          id="Fa1"
          className="st2"
          d="M-288.1,10.6h27.4l0,0v116.1c0,1.7-1.3,3-3,3h-21.4c-1.7,0-3-1.3-3-3V10.6L-288.1,10.6z"
        />
        <path
          id="Sol1"
          className="st2"
          d="M-260.4,10.6h27.4l0,0v116.1c0,1.7-1.3,3-3,3h-21.4c-1.7,0-3-1.3-3-3V10.6L-260.4,10.6z"
        />
        <path
          id="La1"
          className="st2"
          d="M-232.8,10.6h27.4l0,0v116.1c0,1.7-1.3,3-3,3h-21.4c-1.7,0-3-1.3-3-3V10.6L-232.8,10.6z"
        />
        <path
          id="Si1"
          className="st2"
          d="M-205.2,10.6h27.4l0,0v116.1c0,1.7-1.3,3-3,3h-21.4c-1.7,0-3-1.3-3-3V10.6L-205.2,10.6z"
        />
        <rect
          id="Do#1_Re♭1"
          x="-351.9"
          y="10.6"
          className="st3"
          width="17"
          height="82.7"
        />
        <rect
          id="Re#1_Mi♭1"
          x="-324.3"
          y="10.6"
          className="st3"
          width="17"
          height="82.7"
        />
        <rect
          id="Fa#1_Sol♭1"
          x="-269"
          y="10.6"
          className="st3"
          width="17"
          height="82.7"
        />
        <rect
          id="Sol#1_La♭1"
          x="-241.4"
          y="10.6"
          className="st3"
          width="17"
          height="82.7"
        />
        <rect
          id="La#1_Si♭1"
          x="-213.8"
          y="10.6"
          className="st3"
          width="17"
          height="82.7"
        />
        <path
          id="Do2"
          className="st2"
          d="M-177.5,10.6h27.4l0,0v116.1c0,1.7-1.3,3-3,3h-21.4c-1.7,0-3-1.3-3-3V10.6L-177.5,10.6z"
        />
        <path
          id="Re2"
          className="st2"
          d="M-149.9,10.6h27.4l0,0v116.1c0,1.7-1.3,3-3,3h-21.4c-1.7,0-3-1.3-3-3V10.6L-149.9,10.6z"
        />
        <path
          id="Mi2"
          className="st2"
          d="M-122.3,10.6h27.4l0,0v116.1c0,1.7-1.3,3-3,3h-21.4c-1.7,0-3-1.3-3-3V10.6L-122.3,10.6z"
        />
        <path
          id="Fa2"
          className="st2"
          d="M-94.3,10.6h27.4l0,0v116.1c0,1.7-1.3,3-3,3h-21.4c-1.7,0-3-1.3-3-3V10.6L-94.3,10.6z"
        />
        <path
          id="Sol2"
          className="st2"
          d="M-66.8,10.6h27.4l0,0v116.1c0,1.7-1.3,3-3,3h-21.4c-1.7,0-3-1.3-3-3V10.6L-66.8,10.6z"
        />
        <path
          id="La2"
          className="st2"
          d="M-39.4,10.6h27.4l0,0v116.1c0,1.7-1.3,3-3,3h-21.4c-1.7,0-3-1.3-3-3V10.6L-39.4,10.6z"
        />
        <rect
          id="Do#2_Re♭2"
          x="-158.5"
          y="10.6"
          className="st3"
          width="17"
          height="82.7"
        />
        <rect
          id="Re#2_Mi♭2"
          x="-130.9"
          y="10.6"
          className="st3"
          width="17"
          height="82.7"
        />
        <rect
          id="Fa#2_Sol♭2"
          x="-75.3"
          y="10.6"
          className="st3"
          width="17"
          height="82.7"
        />
        <rect
          id="Sol#2_La♭2"
          x="-47.9"
          y="10.6"
          className="st3"
          width="17"
          height="82.7"
        />
        <path
          id="la"
          className="st2"
          d="M-426.3,10.6h27.4l0,0v116.1c0,1.7-1.3,3-3,3h-21.4c-1.7,0-3-1.3-3-3V10.6L-426.3,10.6z"
        />
        <path
          id="si"
          className="st2"
          d="M-398.8,10.6h27.4l0,0v116.1c0,1.7-1.3,3-3,3h-21.4c-1.7,0-3-1.3-3-3V10.6L-398.8,10.6z"
        />
        <rect
          id="la#_si♭"
          x="-407.3"
          y="10.6"
          className="st3"
          width="17"
          height="82.7"
        />
      </g>
    );
  };

  render() {
    const { currentNote } = this.props;
    let currentNoteString  = undefined;

    const svgWidth = 415;
    const svgHeight = 135;
    
    if (currentNote) {
      currentNoteString = currentNote.traditionalName()+(currentNote.octave-3);
      console.log("currentNoteString ",currentNoteString)
    }
    return (
      <div style={{textAlign:'center'}}>
        <svg id="piano_svg" className="piano" viewBox={[0, 0, svgWidth, svgHeight].join(' ')}>{this.drawPiano(currentNoteString)}</svg>
      </div>
    );
  }
}

export default Piano;
